import React from 'react';

function NotificationPanel({ notifications, unreadCount, deleteNotification, setSelectedNotif }) {
  return (
    <div className="notifications-section animate-up">
      <div className="glass-card" style={{padding: '40px'}}>
        <h2 style={{fontSize: '2rem', fontWeight: '800', marginBottom: '10px', letterSpacing: '-1px'}}>Pulse Monitor (Broadcasts)</h2>
        <p style={{color: 'var(--text-secondary)', marginBottom: '40px', fontSize: '1.1rem'}}>Official synchronization logs and platform intelligence updates.</p>
        
        <div className="notifications-list">
          {notifications.length > 0 ? notifications.map(notif => {
            let iconClass = "fa-circle-info";
            if (notif.type === 'success') iconClass = "fa-circle-check";
            if (notif.type === 'warning') iconClass = "fa-triangle-exclamation";
            if (notif.type === 'critical' || notif.type === 'danger') iconClass = "fa-circle-exclamation";

            return (
              <div 
                key={notif.notificationId} 
                className={`notif-item theme-${notif.type} glass-card`}
                onClick={() => setSelectedNotif(notif)}
                style={{cursor: 'pointer', marginBottom: '20px', padding: '25px'}}
              >
                <div className="notif-icon">
                  <i className={`fa-solid ${iconClass}`}></i>
                </div>
                <div className="notif-content">
                  <div className="notif-header" style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
                    <span className="notif-type-tag" style={{fontWeight: '800', fontSize: '0.75rem', letterSpacing: '1px'}}>{notif.type.toUpperCase()}</span>
                    <span className="notif-date" style={{fontSize: '0.8rem', opacity: 0.6}}>{new Date(notif.createdAt).toLocaleDateString()}</span>
                  </div>
                  <h4 style={{fontSize: '1.1rem', marginBottom: '8px'}}>{notif.title}</h4>
                  <p style={{fontSize: '0.9rem', color: 'var(--text-secondary)'}}>{notif.message.substring(0, 100)}...</p>
                </div>
              </div>
            );
          }) : (
            <div className="empty-notifs" style={{textAlign: 'center', padding: '60px 0'}}>
              <i className="fa-solid fa-bell-slash" style={{fontSize: '3rem', opacity: 0.1, marginBottom: '20px'}}></i>
              <p style={{color: 'var(--text-secondary)'}}>Core Silence: No active broadcasts detected.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NotificationPanel;
